import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puzth = () => {
    return (
        <div>
             <NavLink to='/category/Puzzels/Puzzel4'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel2'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;- Previous page</Button>
</NavLink>
            <article className='container'>
    <div class="title"><h1> Calculate total distance travelled by bee</h1></div>
   
    <div class="text">
        <p><strong><u>Puzzle</u>:</strong> Two trains are on same track and they are coming toward each other. The speed
            of the first train is 50 km/h and the speed of the second train is 70 km/h. A bee starts flying between the
            trains when the distance between two trains is 100 km. The bee first flies from first train to second train.
            Once it reaches the second train, it immediately flies back to the first train … and so on until trains
            collide. Calculate the total distance travelled by the bee. Speed of bee is 80 km/h.<br/></p>
        <p>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;</p>
        <p><strong><u>Answer</u>:</strong> 66.67 km approx.</p>
        <p><strong><u>Solution</u>:</strong><br/></p>
        <li>Let the first train A move at <strong>u</strong> km/h.</li>
        <li>Let the second train B move at <strong>v</strong> km/h.</li>
        <li>Let the distance between two trains be <strong>d</strong> km</li>
        <li>Let the speed of bee be <b>b</b> km/h</li>
        <li>Therefore, the time taken by trains to collide = <strong>d/(u+v)</strong>
            <p>Now putting all the known values into the above equation, we get,</p>
            <pre className='containers'>u = 50 km/hr <br/>
    v = 70 km/hr <br/>
    d = 100 km <br/>
    b = 80 km/hr <br/>
     <br/>
    Therfore, the total distance travelled by bee  <br/>
    = b*d/(u+v)  <br/>
    = 80 * 100/(50+70)  <br/>
    = <strong>66.67 km (approx)</strong> <br/>
    </pre> <br/>
           
            
        </li>
    </div>
</article>
        </div>
    )
}

export default Puzth
